import React from 'react';
import './Vault.scss';
import * as _ from "lodash";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Tooltip from "@material-ui/core/Tooltip";
import * as moment from "moment";
import {compose} from "redux";
import {connect} from "react-redux";
import {openConfirmationModal, toggleLoading} from "../../redux/reducers/utils";
import {
  accessDelayMapping, ADVISOR,
  GUARDIAN,
  KEYHOLDER,
  OWNER,
  VAULT_ICON_COLOR_MAPPING,
  VAULT_STATUS_DESCRIPTION_MAPPING,
  VAULT_STATUS_ICON_MAPPING,
  VAULT_STATUS_TEXT_MAPPING
} from "../../config/constants";
import {navigate} from "@reach/router";
import Button from "@material-ui/core/Button";


function VaultStatus(props) {
  const vault = props.vault;

  const getGuardianStatus = (guardian) => {
    switch(guardian.status) {
      case "APPROVED":
        return <div>
          <FontAwesomeIcon icon={"check"} className="mr-2 text-primary"/>
          <span>Approved Request</span>
        </div>;
      case "REJECTED":
        return <div>
          <FontAwesomeIcon icon={"times"} className="mr-2 text-alert"/>
          <span>Rejected Request</span>
        </div>;
      case "PENDING":
        return <div>
          <FontAwesomeIcon icon={"question-circle"} className="mr-2"/>
          <span>Awaiting Response</span>
        </div>;
    }
  }

  const getVaultAccessRequest = () => {
    switch (vault.status) {
      case 'LOCKED':
        return <div className={`fit-content m-auto my-8 access-request-container-locked`}>
          <div className="text-lg text-center">
            <p className="mb-3">No pending access requests at this time.</p>
            {
              vault.guardians.length ?
                <span className="text-sm">At least { vault.number_approvals } Guardian{ vault.guardians.length !== 1 ? 's' : '' } will need to approve an access request per vault settings.</span> :
                <span className="text-sm">No Guardians have been assigned, so Keyholder requests will be automatically approved.</span>
            }
          </div>
        </div>;
      case 'ARCHIVED':
        return null;
      case 'PENDING':
      case 'UNLOCKED':
        return <div className="mb-8">
          <div className={`py-8 w-full m-auto access-request-container-${vault.status === 'UNLOCKED' ? 'approved' : 'pending'}`}>
            <div className="flex flex-col sm:flex-row center-xs middle-xs">
              <FontAwesomeIcon icon={vault.status === 'UNLOCKED' ? 'check-circle' : 'exclamation-circle'}
                               className={`${vault.status === 'UNLOCKED' ? 'text-primary' : 'text-warning'} right-spacer text-3xl md:text-5xl sm:mr-5 mb-3 sm:mb:0`}/>
              <div className="sm:flex-1 w-full text-sm sm:text-base">
                <p className="text-left">Keyholder '<b>{vault.access_request['requested_by_name']}</b>' requested access
                  on <b>{vault.accessRequestedAt}</b> with the note:</p>
                <p
                  className="text-sm text-grey left-spacer my-4 text-left">"{vault.access_request.reason}"</p>
                {vault.status === 'PENDING' ?
                  <p className="text-left">The request has been approved by <b
                    className="text-base sm:text-lg">{vault.approvals || 0}</b> of <b
                    className="text-base sm:text-lg">{vault.number_approvals}</b> required Guardians.</p>

                  :
                  <p className="text-left">The request was approved on <b>{vault.accessRequestCompletedAt}</b>.</p>
                }
                {
                  vault.access_request.guardians && vault.access_request.guardians.length &&
                  <div className="mt-3 m-auto">
                    {
                      _.map(vault.access_request.guardians, (guardian) =>
                        <div className="flex flex-col text-left sm:flex-row access-request-row" key={guardian.name}>
                          <p className="access-request-name-text mb-2 sm:mb-0">{guardian.name}</p>
                          {getGuardianStatus(guardian)}
                        </div> )
                    }
                  </div>
                }
              </div>
            </div>
          </div>
          {
            vault.accessDelayed &&
            <div className="mt-3 access-request-container-pending fit-content m-auto bottom-spacer">
              <div className="flex items-center">
                <FontAwesomeIcon icon={'exclamation-circle'}
                                 className={'text-warning right-spacer'}
                                 size="2x"/>
                <p className="flex-1">The Owner has configured a delay of {accessDelayMapping[vault.access_delay]} before documents can be dowloaded. Documents will be available on <span className="font-bold">{moment(vault.unlocked_at).format('LLL')}</span>.</p>
              </div>
            </div>
          }
        </div>;
    }
  }

  const getVaultAction = () => {
    switch(vault.role) {
      case ADVISOR:
      case OWNER:
        switch (vault.status) {
          case 'LOCKED':
            return <div className="flex flex-col sm:flex-row items-center w-full center-xs">
              <Button
                variant="contained"
                onClick={() => navigate(`/vaults/${vault.id}/edit`)}
                className="w-full vault-status-button"
                color="secondary">
                          <span className="flex items-center">
                            <FontAwesomeIcon icon="edit" className="mr-2"/>
                            <p>Edit Vault</p>
                          </span>
              </Button>
              <div className="sm:ml-5 mt-5 sm:mt-0 w-full vault-status-button">
                <Button
                  variant="outlined"
                  className="w-full"
                  onClick={() => props.openConfirmationModal("ARCHIVE_VAULT", () => props.performVaultAction('TOGGLE_VAULT_ARCHIVED'))}
                >
                    <span className="flex items-center">
                      <FontAwesomeIcon icon="box" className="mr-2"/>
                      <p>Archive Vault</p>
                    </span>
                </Button>
              </div>
            </div>
          case 'PENDING':
            return <div>
              <p className="text-center top-spacer-large">As <b>the Owner</b> of this vault, please decide if access to the vault should be granted.</p>
              <p className="text-center mt-2">If you need more information on this process, <a>please see our FAQ</a>.</p>
              <div className="sm:flex items-center w-full center-xs mt-6">
                <Button
                  variant="contained"
                  onClick={() => props.performVaultAction('APPROVE_VAULT_ACCESS_REQUEST')}
                  className="vault-status-button w-full"
                  color="secondary">
                          <span className="flex items-center">
                            <FontAwesomeIcon icon="check" className="mr-2"/>
                            <p>Approve Access</p>
                          </span>
                </Button>
                <div className="left-spacer error-button">
                  <Button
                    variant="outlined"
                    onClick={() => props.performVaultAction('REJECT_VAULT_ACCESS_REQUEST')}
                    className="light-red text-white vault-status-button w-full"
                  >
                        <span className="flex items-center">
                          <FontAwesomeIcon icon="times" className="mr-2"/>
                          <p>Reject Access</p>
                        </span>
                  </Button>
                </div>
              </div>
            </div>;
          case 'UNLOCKED':
            return <div>
              <p className="text-center top-spacer-large">While the vault is unlocked, no changes can be made.</p>
              <div className="flex items-center w-full center-xs mt-3">
                <Button
                  variant="contained"
                  onClick={() => props.openConfirmationModal("LOCK_VAULT", () => props.performVaultAction('LOCK_VAULT'))}
                  color="primary">
                            <span className="flex items-center">
                              <FontAwesomeIcon icon="lock" className="mr-2"/>
                              <p>Lock Vault</p>
                            </span>
                </Button>
              </div>
            </div>;
          case 'ARCHIVED':
            return <div>
              <p className="text-center mt-3">While the vault is archived, no changes can be made.</p>
              <p className={"text-center"}>Un-archive the vault to make it active again.</p>
              <div className="flex items-center w-full center-xs mt-3">
                <Button
                  variant="contained"
                  onClick={() => props.performVaultAction('TOGGLE_VAULT_ARCHIVED')}
                  color="secondary">
                      <span className="flex items-center">
                        <FontAwesomeIcon icon="box-open" className="mr-2"/>
                        <p>Un-archive Vault</p>
                      </span>
                </Button>
              </div>
            </div>
        }
        break;

      case GUARDIAN:
        if (vault.status === 'PENDING') {
          return <div>
            <p className="text-center top-spacer-large">As <b>{ vault.role === OWNER ? "the Owner" : 'a Guardian' }</b> of this vault, please decide if access to the vault should be granted.</p>
            <p className="text-center mt-2">If you need more information on this process, <a>please see our FAQ</a>.</p>
            <div className="sm:flex text-center items-center w-full center-xs mt-6">
              <Button
                variant="contained"
                onClick={() => props.performVaultAction('APPROVE_VAULT_ACCESS_REQUEST')}
                className="vault-status-button w-full"
                color="secondary">
                                  <span className="flex items-center">
                                    <FontAwesomeIcon icon="check" className="mr-2"/>
                                    <p>Approve Access</p>
                                  </span>
              </Button>
              <div className="sm:ml-5 mt-3 sm:mt-0 error-button">
                <Button
                  variant="outlined"
                  className={"vault-status-button w-full"}
                  onClick={() => props.performVaultAction('REJECT_VAULT_ACCESS_REQUEST')}
                >
                      <span className="flex items-center">
                        <FontAwesomeIcon icon="times" className="mr-2"/>
                        <p>Reject Access</p>
                      </span>
                </Button>
              </div>
            </div>
          </div>;
        } else if (vault.status === 'ARCHIVED') {
          return <div>
            <p className="text-center mt-3">The Vault is inactive while Archived and no requests for access can be made.</p>
          </div>
        }
        break;

      case KEYHOLDER:
        switch (vault.status) {
          case 'LOCKED':
            return <Button
              variant="contained"
              onClick={props.openAccessRequestModal}
              color="secondary">
                          <span className="flex items-center">
                            <FontAwesomeIcon icon="users" className="mr-2"/>
                            <p>Request Access</p>
                          </span>
            </Button>;
          case 'PENDING':
            return <Button
              variant="outlined"
              onClick={() => props.openConfirmationModal("CANCEL_REQUEST", () => props.performVaultAction('CANCEL_VAULT_ACCESS_REQUEST'))}
              className=""
            >
                          <span className="flex items-center">
                            <FontAwesomeIcon icon="times" className="mr-2"/>
                            <p>Cancel Request</p>
                          </span>
            </Button>;
          case 'ARCHIVED':
            return <div>
              <p className="text-center mt-3">The Vault is inactive while Archived and no requests for access can be made.</p>
            </div>
        }
    }
  };

  return (
    <>
      <div className="text-center mb-3">
        <FontAwesomeIcon icon={VAULT_STATUS_ICON_MAPPING[vault.status]} size="5x"
                         className={`bottom-spacer-medium cursor-pointer ${VAULT_ICON_COLOR_MAPPING[vault.status]}`}/>
        <Tooltip title={VAULT_STATUS_DESCRIPTION_MAPPING[vault.status]}>
          <p className="text-2xl sm:text-3xl cursor-pointer">
            { VAULT_STATUS_TEXT_MAPPING[vault.status] }
          </p>
        </Tooltip>
      </div>

      {
        getVaultAccessRequest()
      }

      <div className="text-center">
        {
          getVaultAction()
        }
      </div>
    </>
  );
};

const mapStateToProps = (state, props) => {
  return {
    ...props,
    user: state.user.user
  };
};

export default compose(
  connect(
    mapStateToProps,
    { toggleLoading, openConfirmationModal }
  )
)(VaultStatus);

